"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pluralize = pluralize;
exports.singularize = singularize;

var _defaultVocabulary = _interopRequireDefault(require("./defaultVocabulary"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Pluralises the provided input considering irregular words
 * @param word Word to be pluralised
 * @param isKnownToBeSingular Normally you call `pluralize` on singular words, but if you're unsure set this to false
 */
function pluralize(word) {
  var isKnownToBeSingular = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return _defaultVocabulary["default"].pluralize(word, isKnownToBeSingular);
}
/**
 * Singularises the provided input considering irregular words
 * @param word Word to be singularised
 * @param isKnownToBePlural Normally you call `singularize` on plural words, but if you're unsure set this to false
 * @param skipSimpleWords Skip singularising simple words that have an 's' on the end (assumes default vocabulary)
 */


function singularize(word) {
  var isKnownToBePlural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var skipSimpleWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return _defaultVocabulary["default"].singularize(word, isKnownToBePlural, skipSimpleWords);
}